import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '@modules/core/services/config.service';
import { AppStoreService } from '@modules/core/store/app-store.service';

@Component({
  selector: 'app-template-highspeed-courses',
  templateUrl: './template-highspeed-courses.component.html',
  styleUrls: ['./template-highspeed-courses.component.scss']
})
export class TemplateHighspeedCoursesComponent implements OnInit,OnDestroy {

  constructor(private configService: ConfigService, private appStoreService: AppStoreService) { }

  ngOnInit(): void {
    this.appStoreService.setHomePageFlag(true);
  }

  get bannerImage() {
    const env = this.configService.getCurrent().env;
    switch (env) {
      case 'production':
        return 'https://rssjoliv-prod.imgix.net/hoyhastighet/hastighetskurs.jpg';
      case 'staging':
        return 'https://rssjoliv-staging.imgix.net/hoyhastighet/hastighetskurs.jpg';
      default:
        return 'https://rssjoliv-dev.imgix.net/hoyhastighet/hastighetskurs.jpg';
    }
  }

  ngOnDestroy(): void {
      this.appStoreService.setHomePageFlag(false);
  }


}
